import { getAllCommission } from "@/services/pricing-config.service";
import { useQuery } from "@tanstack/react-query";

export const useAllCommission = (
  enabled = true,
  params = { page: 0, size: 10, search: "" },
  options = {},
) => {
  const queryKey = [
    "all-commissions",
    params.page,
    params.size,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getAllCommission(params),
    enabled,
    ...options,
  });
};